<template>
  <v-container fluid class="page-wrap">
    <v-row>
      <v-col cols="12" class="text-center">
          <header-vue/>
      </v-col>

      <v-col
        class="mb-3"
        md="12"
      >
            <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
                <v-card-title class="page-title-row">
                    <div>
                        <div class="text-overline accent--text font-weight-bold">ATTENDANCE</div>
                        <div class="text-h6 font-weight-bold primary--text">Attendance Summary</div>
                        <div class="text-body-2 grey--text">See all your record's attendance for terms and classes</div>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" md="3">
                            <v-select v-model="selectedTerm" :items="terms" item-value="parameter_id" item-text="term_session" label="Term" outlined dense prepend-inner-icon="mdi-calendar-range" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select v-model="selectedClass" :items="classes" item-text="class"
                                        item-value="class_id"
                                        label="Select Class" outlined dense prepend-inner-icon="mdi-google-classroom" />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-select v-model="selectedChart" :items="chartOptions"
                            item-text="label"
                            item-value="value" label="Chart Type" outlined dense prepend-inner-icon="mdi-chart-box-outline" />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-btn color="primary" rounded elevation="2" block class="font-weight-bold text-none" @click="loadAttendance">
                                <v-icon left>mdi-magnify</v-icon>
                                Load
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row v-if="records.length">
                        <v-col cols="12" class="mt-2">
                            <attendance-bar-chart v-if="chartViewType == 'bar'" :data="records"/>
                            <attendance-line-chart v-if="chartViewType == 'line'" :data="records"/>
                            <attendance-pie-chart v-if="chartViewType == 'pie'" :data="records"/>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" class="mt-2">
                            <v-card outlined class="rounded-lg">
                                <v-card-title class="text-subtitle-1 font-weight-bold primary--text">
                                    Attendance Summary
                                </v-card-title>
                                <v-data-table
                                    :headers="headers"
                                    :items="records"
                                    class="elevation-0"
                                    dense
                                    disable-pagination
                                    hide-default-footer
                                    sort-by="full_name"
                                >
                                    <template v-slot:item.full_name="{ item }">
                                    <strong>{{ item.full_name }}</strong>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import HeaderVue from '../../components/Header.vue'
import AttendanceBarChart from '../../components/attendanceModule/AttendanceBarChart.vue';
import AttendanceLineChart from '../../components/attendanceModule/AttendanceLineChart.vue';
import AttendancePieChart from '../../components/attendanceModule/AttendancePieChart.vue';
export default {
    components: {
        HeaderVue,
        AttendanceBarChart,
        AttendanceLineChart,
        AttendancePieChart
    },
    data() {
        return {
            selectedClass: '',
            selectedTerm: '',
            selectedChart: 'bar',
            chartOptions: [
                { value: 'bar', label: 'Bar' },
                { value: 'line', label: 'Line (1 Token 🔒)' },
                { value: 'pie', label: 'Pie (1 Token 🔒)' }
            ],
            chartViewType: 'bar',
            terms: [],
            records: [],
            statuses: ['punctual', 'absent', 'late'],
            authToken:sessionStorage.getItem('authToken') ?? null,
            accessToken:sessionStorage.getItem('accessToken') ?? null,
            school:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : {},
            classes:[],
            headers: [
                { text: 'Student', value: 'full_name', sortable: true },
                { text: 'Total Present Days', value: 'present', sortable: true },
                { text: 'Total Absent Days', value: 'absent', sortable: true },
                { text: 'Days Punctual', value: 'punctual', sortable: true },
                { text: 'Days Late', value: 'late', sortable: true }
            ],

        };
    },
    mounted() {
       this.fetchClasses()
       this.fetchTerms()
    },
    methods: {
        loadAttendance() {
            if (!this.selectedClass || !this.selectedTerm) {
                return false;
            }

            if (this.selectedChart == 'pie' || this.selectedChart == 'line') {
                if(confirm("This chart will consume 1 token, Do you want to continue?")){
                    //sent token deduction
                    this.chartViewType = this.selectedChart;
                }
            }else{
                this.chartViewType = 'bar';
            }
            axios.get(process.env.VUE_APP_BASEURL+'/attendances/student-summary?school_id='+this.school.school_id+'&clasx_id='+this.selectedClass+'&parameter_id='+this.selectedTerm,
            {
                headers:
                    {
                        'Authorization': 'Bearer '+this.authToken,
                        'X-Access-Token': this.accessToken,
                    }
            })
            .then((res) => {
                this.records = res.data.records;
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'APP is temporarily unavailable. Wait or Contact us!', {
                    timeout: 5000
                });
            })
        },
        fetchClasses () {
            axios.get(process.env.VUE_APP_BASEURL+'/classes?school_id='+this.school.school_id+'&type=dropdown',
            {
                headers:
                {
                    'Authorization': 'Bearer '+this.authToken,
                    'X-Access-Token': this.accessToken,
                }
            })
            .then((response) => {
                this.classes =  response.data.data
                    if (this.classes.length == 0) {
                    this.$toast.info('You will need to set classes first!', {
                            timeout: 5000
                        });
                    this.$router.push({name: 'Classes'})
                }
                this.reRenderComponent = false;
                this.$nextTick(() => {
                // Add the component back in
                this.reRenderComponent = true;
                });
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Internet Network Not Available!', {
                    timeout: 5000
                });
            })
        },
        fetchTerms () {
            axios.get(process.env.VUE_APP_BASEURL+'/parameters?school_id='+this.school.school_id+'&type=dropdown',
            {
                headers:
                    {
                        'Authorization': 'Bearer '+this.authToken,
                        'X-Access-Token': this.accessToken,
                    }
            })
            .then((response) => {
                this.terms =  response.data.data
                if (!this.terms) {
                    this.$toast.info('You will need to set a session/term first!', {
                            timeout: 5000
                        });
                    this.$router.push({name: 'Terms'})
                }
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'APP is temporarily unavailable. Wait or Contact us!', {
                    timeout: 5000
                });
            })
            .finally(() => {
            });
        },

  }
}
</script>
